// import React, { useState } from 'react';
// import {
//   Box,
//   Button,
//   Grid,
//   Paper,
//   TextField,
//   Typography,
//   CssBaseline,
//   Container,IconButton ,
// } from '@mui/material';
// import { ToastContainer, toast } from 'react-toastify';
// import axios from 'axios';
// import 'react-toastify/dist/ReactToastify.css';
// import Header2 from '../../Component/Header2';
// import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
// import { useNavigate } from 'react-router-dom';

// const EmployeeRegistrationForm = () => {
//   const [formData, setFormData] = useState({
//     employeeName: '',
//     address: '',
//     mobileNumber: '',
//     email: '',
//     joiningDate: '',
//     username: '',
//     password: '',
//   });
//   const shopkeeperId = localStorage.getItem("shopkeeperID");
// const navigate = useNavigate();
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({ ...prev, [name]: value }));
//   };

//   const validateFields = () => {
//     const { employeeName, address, mobileNumber, email, joiningDate, username, password } = formData;
//     const mobileRegex = /^[0-9]{10}$/;
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

//     if (!employeeName || !address || !mobileNumber || !email || !joiningDate || !username || !password) {
//       toast.error('⚠️ All fields are required!');
//       return false;
//     }

//     if (!mobileRegex.test(mobileNumber)) {
//       toast.error('📱 Enter a valid 10-digit mobile number.');
//       return false;
//     }

//     if (!emailRegex.test(email)) {
//       toast.error('✉️ Enter a valid email address.');
//       return false;
//     }

//     return true;
//   };

// const handleSubmit = async (e) => {
//   e.preventDefault();
//   if (!validateFields()) return;

//   try {
//     const res = await axios.post("https://sakhisshop.com/api/employee", {
//       ...formData,
//       shopkeeperId,
//     });

//     if (res.data && res.data.error) {
//       // ❌ Backend says employee creation is disabled
//       toast.error(res.data.error);
//       return;
//     }

//     // ✅ Success
//     toast.success("✅ Employee registered successfully!");
//     setFormData({
//       employeeName: '',
//       address: '',
//       mobileNumber: '',
//       email: '',
//       joiningDate: '',
//       username: '',
//       password: '',
//     });
//   } catch (error) {
//     let msg = "❌ Error registering employee. Please try again.";
//     if (error.response && error.response.data && error.response.data.error) {
//       msg = error.response.data.error;
//     }
//     toast.error(msg);
//   }
// };
// // const handleSubmit = async (e) => {
// //   e.preventDefault();
// //   if (!validateFields()) return;

// //   try {
// //     // 👇 Get role from localStorage (set during login)
// //     const role = localStorage.getItem("role");

// //     const res = await axios.post("https://sakhisshop.com/api/employee", {
// //       ...formData,
// //       shopkeeperId,
// //       role, // ✅ Send role so backend knows which permission to check
// //     });

// //     if (res.data && res.data.error) {
// //       toast.error(res.data.error);
// //       return;
// //     }

// //     toast.success("✅ Employee registered successfully!");
// //     setFormData({
// //       employeeName: "",
// //       address: "",
// //       mobileNumber: "",
// //       email: "",
// //       joiningDate: "",
// //       username: "",
// //       password: "",
// //     });
// //   } catch (error) {
// //     let msg = "❌ Error registering employee. Please try again.";
// //     if (error.response?.data?.error) {
// //       msg = error.response.data.error;
// //     }
// //     toast.error(msg);
// //   }
// // };
//   return (
//     <>
//     <Header2/>
//       <CssBaseline />
//    <Box
//   sx={{
//     backgroundColor: '#f2f4f7',
//     minHeight: '100vh',
//     display: 'flex',
//     alignItems: 'center', // vertically centers the form
//     justifyContent: 'center', // optional: horizontally center if needed
//     py: 0, // remove vertical padding
//   }}
// >
//         <Container maxWidth="md">
//           <Paper elevation={5} sx={{ p: 4, borderRadius: 3 }}>
//             <IconButton onClick={() => navigate(-1)} color="warning">
//       <ArrowBackIosNewIcon />
//     </IconButton>
//             <Typography
//               variant="h5"
//               fontWeight="bold"
//               fontFamily="Poppins"
//               align="center"
//               gutterBottom
//               sx={{ mb: 3 }}
//             >
//               Employee Registration Form
//             </Typography>

//             <Box component="form" onSubmit={handleSubmit}>
//               <Grid container spacing={2}>
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     fullWidth
//                     label="Employee Name"
//                     name="employeeName"
//                     value={formData.employeeName}
//                     onChange={handleChange}
//                     required
//                   />
//                 </Grid>

//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     fullWidth
//                     label="Address"
//                     name="address"
//                     value={formData.address}
//                     onChange={handleChange}
//                     required
//                   />
//                 </Grid>

//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     fullWidth
//                     label="Mobile Number"
//                     name="mobileNumber"
//                     type="tel"
//                     value={formData.mobileNumber}
//                     onChange={handleChange}
//                     required
//                     inputProps={{ maxLength: 10 }}
//                   />
//                 </Grid>

//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     fullWidth
//                     label="Email"
//                     name="email"
//                     type="email"
//                     value={formData.email}
//                     onChange={handleChange}
//                     required
//                   />
//                 </Grid>

//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     fullWidth
//                     label="Joining Date"
//                     name="joiningDate"
//                     type="date"
//                     InputLabelProps={{ shrink: true }}
//                     value={formData.joiningDate}
//                     onChange={handleChange}
//                     required
//                   />
//                 </Grid>

//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     fullWidth
//                     label="Username"
//                     name="username"
//                     value={formData.username}
//                     onChange={handleChange}
//                     required
//                   />
//                 </Grid>

//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     fullWidth
//                     label="Password"
//                     name="password"
//                     type="password"
//                     value={formData.password}
//                     onChange={handleChange}
//                     required
//                   />
//                 </Grid>

//                 <Grid item xs={12} sm={6} /> {/* Keeps symmetry */}

//                 <Grid item xs={12}>
//                   <Box textAlign="center" mt={1}>
//                     <Button
//                       variant="contained"
//                       type="submit"
//                       size="large"
//                       sx={{
//                         px: 5,
//                         py: 1.5,
//                         borderRadius: 2,
//                         fontWeight: 600,
//                         fontSize: '1rem',
//                         backgroundColor: '#43a047',
//                         '&:hover': { backgroundColor: '#2e7d32' },
//                       }}
//                     >
//                       Register Employee
//                     </Button>
//                   </Box>
//                 </Grid>
//               </Grid>
//             </Box>
//           </Paper>
//         </Container>
//       </Box>

//       <ToastContainer position="top-center" autoClose={3000} hideProgressBar />
//     </>
//   );
// };

// export default EmployeeRegistrationForm;

import React, { useState } from "react";
import {
  Box,
  Button,
  Grid,
  Paper,
  TextField,
  Typography,
  CssBaseline,
  Container,
  IconButton,
} from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import Header2 from "../../Component/Header2";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { useNavigate } from "react-router-dom";

const EmployeeRegistrationForm = () => {
  const [formData, setFormData] = useState({
    employeeName: "",
    address: "",
    mobileNumber: "",
    email: "",
    joiningDate: "",
    username: "",
    password: "",
  });
  const [usernameError, setUsernameError] = useState("");
  const shopkeeperId = localStorage.getItem("shopkeeperID");
  const navigate = useNavigate();
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validateFields = () => {
    const {
      employeeName,
      address,
      mobileNumber,
      email,
      joiningDate,
      username,
      password,
    } = formData;
    const mobileRegex = /^[0-9]{10}$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (
      !employeeName ||
      !address ||
      !mobileNumber ||
      !email ||
      !joiningDate ||
      !username ||
      !password
    ) {
      toast.error("⚠ All fields are required!");
      return false;
    }

    if (!mobileRegex.test(mobileNumber)) {
      toast.error("📱 Enter a valid 10-digit mobile number.");
      return false;
    }

    if (!emailRegex.test(email)) {
      toast.error("✉ Enter a valid email address.");
      return false;
    }

    return true;
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   if (!validateFields()) return;

  //   try {
  //     const res = await axios.post("https://sakhisshop.com/api/employee", {
  //       ...formData,
  //       shopkeeperId,
  //     });

  //     if (res.data && res.data.error) {
  //       // ❌ Backend says employee creation is disabled
  //       toast.error(res.data.error);
  //       return;
  //     }

  //     // ✅ Success
  //     toast.success("✅ Employee registered successfully!");
  //     setFormData({
  //       employeeName: '',
  //       address: '',
  //       mobileNumber: '',
  //       email: '',
  //       joiningDate: '',
  //       username: '',
  //       password: '',
  //     });
  //   } catch (error) {
  //     let msg = "❌ Error registering employee. Please try again.";
  //     if (error.response && error.response.data && error.response.data.error) {
  //       msg = error.response.data.error;
  //     }
  //     toast.error(msg);
  //   }
  // };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateFields()) return;

    try {
      const role = localStorage.getItem("role"); // get role from login
      const res = await axios.post("https://sakhisshop.com/api/employee", {
        ...formData,
        shopkeeperId,
        role,
      });

      if (res.data && res.data.error) {
        toast.error(res.data.error);
        return;
      }

      toast.success("✅ Employee registered successfully!");
      setFormData({
        employeeName: "",
        address: "",
        mobileNumber: "",
        email: "",
        joiningDate: "",
        username: "",
        password: "",
      });
    } catch (error) {
      console.error("❌ Employee registration failed:", error);

      const backendMessage =
        error.response?.data?.error || // backend error
        error.response?.data?.message || // fallback
        "❌ Registration failed. Please try again.";

      // ✅ Inline error ONLY for username
      if (backendMessage.toLowerCase().includes("username")) {
        setUsernameError(backendMessage); // show under Username
        return; // do not show toast
      }

      // ✅ Toast for all other errors
      toast.error(backendMessage);
    }
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   if (!validateFields()) return;

  //   try {
  //     // 👇 Get role from localStorage (set during login)
  //     const role = localStorage.getItem("role");

  //     const res = await axios.post("https://sakhisshop.com/api/employee", {
  //       ...formData,
  //       shopkeeperId,
  //       role, // ✅ Send role so backend knows which permission to check
  //     });

  //     if (res.data && res.data.error) {
  //       toast.error(res.data.error);
  //       return;
  //     }

  //     toast.success("✅ Employee registered successfully!");
  //     setFormData({
  //       employeeName: "",
  //       address: "",
  //       mobileNumber: "",
  //       email: "",
  //       joiningDate: "",
  //       username: "",
  //       password: "",
  //     });
  //   } catch (error) {
  //     let msg = "❌ Error registering employee. Please try again.";
  //     if (error.response?.data?.error) {
  //       msg = error.response.data.error;
  //     }
  //     toast.error(msg);
  //   }
  // };
  return (
    <>
      <Header2 />
      <CssBaseline />
      <Box
        sx={{
          backgroundColor: "#f2f4f7",
          minHeight: "100vh",
          display: "flex",
          alignItems: "center", // vertically centers the form
          justifyContent: "center", // optional: horizontally center if needed
          py: 0, // remove vertical padding
        }}
      >
        <Container maxWidth="md">
          <Paper elevation={5} sx={{ p: 4, borderRadius: 3 }}>
            <IconButton onClick={() => navigate(-1)} color="warning">
              <ArrowBackIosNewIcon />
            </IconButton>
            <Typography
              variant="h5"
              fontWeight="bold"
              fontFamily="Poppins"
              align="center"
              gutterBottom
              sx={{ mb: 3 }}
            >
              Employee Registration Form
            </Typography>

            <Box component="form" onSubmit={handleSubmit}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Employee Name"
                    name="employeeName"
                    value={formData.employeeName}
                    onChange={handleChange}
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Address"
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Mobile Number"
                    name="mobileNumber"
                    type="tel"
                    value={formData.mobileNumber}
                    onChange={handleChange}
                    required
                    inputProps={{ maxLength: 10 }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Email"
                    name="email"
                    type="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Joining Date"
                    name="joiningDate"
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    value={formData.joiningDate}
                    onChange={handleChange}
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Username"
                    name="username"
                    value={formData.username}
                    onChange={(e) => {
                      handleChange(e);
                      setUsernameError(""); // clear error while typing
                    }}
                    required
                    error={!!usernameError} // show red outline if error
                    helperText={usernameError} // show message under field
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Password"
                    name="password"
                    type="password"
                    value={formData.password}
                    onChange={handleChange}
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={6} /> {/* Keeps symmetry */}
                <Grid item xs={12}>
                  <Box textAlign="center" mt={1}>
                    <Button
                      variant="contained"
                      type="submit"
                      size="large"
                      sx={{
                        px: 5,
                        py: 1.5,
                        borderRadius: 2,
                        fontWeight: 600,
                        fontSize: "1rem",
                        backgroundColor: "#43a047",
                        "&:hover": { backgroundColor: "#2e7d32" },
                      }}
                    >
                      Register Employee
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Paper>
        </Container>
      </Box>

      <ToastContainer position="top-center" autoClose={3000} hideProgressBar />
    </>
  );
};

export default EmployeeRegistrationForm;
